import { TGetReceiptPdfConfig } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function getReceiptConfig({
  doctor_oid,
  clinic_id,
}: {
  doctor_oid: string;
  clinic_id: string;
}): Promise<TrystGenericResponse<TGetReceiptPdfConfig[]>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${TRYST_HOST}/receipt/receipt-pdf-config/${doctor_oid}/${clinic_id}`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    console.error(error);
    return {
      success: false,
    };
  }
}
